import { render, staticRenderFns } from "./ModuleButton.vue?vue&type=template&id=06bf26c9&scoped=true&"
import script from "./ModuleButton.vue?vue&type=script&lang=js&"
export * from "./ModuleButton.vue?vue&type=script&lang=js&"
import style0 from "./ModuleButton.vue?vue&type=style&index=0&id=06bf26c9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf26c9",
  null
  
)

export default component.exports